import { getLocalStore } from 'utils/commonFunc';

export default {
  // API_BASE_URL: 'http://localhost:5001',
  API_BASE_URL: 'https://api.tanacademy.in',
  roles: {
    guardian: 'ROLE_GUARD',
    teacher: 'ROLE_TEACHER',
    admin: 'ROLE_ADMIN',
    SA: 'ROLE_SUPER_ADMIN',
  },
  setHeader: (token, currentUserId, isMutipart, passController) => {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(currentUserId && { currentUserId }),
        ...(!!isMutipart && { 'Content-Type': 'multipart/form-data' }),
      },
      signal: passController?.signal,
    };
  },
  makeParams: (params, canAppend = false) => {
    if (params) {
      return `${canAppend ? '&' : '?'}${Object.keys(params)
        .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
        .join('&')}`;
    }
    return '';
  },
};

export const makeFirstCaps = str => {
  if (str && typeof str === 'string') {
    return str?.charAt(0).toUpperCase() + str.substring(1).toLowerCase();
  }
  return '';
};

export const capitalize = str => {
  if (str && typeof str === 'string') {
    return str?.replace(/^./, strItem => `${strItem.toUpperCase()}`);
  }
  return '';
};

export const formStudentName = student => {
  return capitalize(
    `${student?.firstName?.trim()}${
      student?.middleName ? ` ${student?.middleName?.trim()}` : ''
    } ${student?.lastName?.trim()}`
  );
};

export const courseStageList = [
  { label: 'Primary (PreKg - 5th)', value: 'PRIMARY' },
  { label: 'Secondary (6th - 10th)', value: 'SECONDARY' },
  { label: 'Higher Secondary (11th - 12th)', value: 'HIGHER_SECONDARY' },
  { label: 'Diplomo (Course)', value: 'DIPLOMO' },
  { label: 'Degree (Graduate)', value: 'DEGREE' },
  { label: 'General', value: 'GENERAL' },
];
export const courseStages =
  'PRIMARY (PRE_KG - 5th), SECONDARY (6th - 10th), HIGHER_SECONDARY (11th - 12th), DIPLOMO (Course), DEGREE (Graduate), GENERAL';

const commonConfigStore = getLocalStore('commonConfig');
const teacherName = commonConfigStore?.find(el => el.configName === 'LABEL_TEACHER')?.configValue;
const className = commonConfigStore?.find(el => el.configName === 'LABEL_CLASS')?.configValue;
const regNoName = commonConfigStore?.find(el => el.configName === 'LABEL_REG_NO')?.configValue;
console.log({ teacherName, className, regNoName });
export let courseStatic = className ? makeFirstCaps(className) : 'Class';
export let coursesStatic = className ? `${makeFirstCaps(className)}s` : 'Classes';
export let employeeStatic = teacherName ? makeFirstCaps(teacherName) : 'Teacher';
export let employeesStatic = teacherName ? `${makeFirstCaps(teacherName)}s` : 'Teachers';
// School admins kept confusing "Reg No" with "Admission No" (and vice versa) - rather than pick
// one, let each school configure which term their staff already uses, the same way they already
// do for Teacher/Class labels above.
const regNoLabels = { REG_NO: 'Reg No', ADMISSION_NO: 'Admission No' };
export let regNoStatic = regNoLabels[regNoName] || 'Reg No';
// The Android app's Play Store page (same link the mobile app opens for "Update").
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.schoolmanagementscholae';

// Payment modes offered wherever a payment is recorded. value is the backend's PaymentMode enum, which unofficial bills
// send. Student fee payments store the mode as plain text, so that form sends the label instead and receipts keep
// reading "Cash", "UPI" etc. like the payments already stored.
export const PAYMENT_MODES = [
  { label: 'Cash', value: 'CASH' },
  { label: 'UPI', value: 'UPI' },
  { label: 'Card', value: 'CARD' },
  { label: 'Cheque', value: 'CHEQUE' },
  { label: 'Bank Transfer', value: 'BANK_TRANSFER' },
];
